// Form validation for Technician Group form
import { multiselectValidator, plaintextValidator } from '../fields';

const config = {};

export default {
  name: plaintextValidator({ mandatory: true }),
  description: plaintextValidator(config),
  technicians: multiselectValidator(config),
  clients: multiselectValidator(config)
};
